import * as Sentry from '@sentry/browser';
import _isPlainObject from 'lodash/isPlainObject';

export default function logError(error, extra) {
  if (process.env.REACT_APP_MODE === 'DEVELOPMENT') {
    console.log('Log Error: ', error);
  }

  if (_isPlainObject(extra)) {
    Sentry.withScope(scope => {
      Object.keys(extra).forEach(key => {
        scope.setExtra(key, extra[key]);
      });
    });
  }

  Sentry.captureException(error);
}
